import React from 'react'
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid2';
import Error from '../../Images/error-404.png'
import Button from "@mui/material/Button";
import HomeTwoToneIcon from '@mui/icons-material/HomeTwoTone';
import './Error404.css'
import { Link } from 'react-router-dom';



const Error404 = () => {
  return (
    <div className='Error-404-section'>
      <Box sx={{ display: "flex", height: '100vh', width: '100%', alignItems: 'center', justifyContent: 'center' }}>
        <div className='Error-404-section-main'>

          <Grid container spacing={3} sx={{ justifyContent: 'center', alignContent: 'center' }}>
            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} sx={{ justifyContent: 'center', alignContent: 'center' }}>
              <div className='Error-404-section-main-card'>
                <img src={Error} alt="Error" />
                <Typography variant="h5" component="h5">
                Page Not Found
                </Typography>
                <Typography variant="body2">
                This page doesn’t exist or was removed! We suggest you go back to home.
                </Typography>
                <div className="home404-button">
                  <Link to="/" >
                    <HomeTwoToneIcon /> Back to home
                  </Link>
                </div>
              </div>

            </Grid>
          </Grid>

        </div>
      </Box>
    </div>
  )
}

export default Error404